"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.HeroBannerHomeComponent = void 0;
var app_1 = require("app");
var KeepTheRhythm_1 = require("../KeepTheRhythm");
var HeroBannerHomeComponent = /** @class */ (function (_super) {
    __extends(HeroBannerHomeComponent, _super);
    function HeroBannerHomeComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.selector = ".hero-banner-home";
        return _this;
    }
    HeroBannerHomeComponent.prototype.BeforeInit = function () {
        this.FixStyles();
    };
    HeroBannerHomeComponent.prototype.OnInit = function () {
        this.FixStyles();
    };
    HeroBannerHomeComponent.prototype.FixStyles = function () {
        if (!this.$el.hasClass("hero-banner-home--gray")) {
            return;
        }
        var sibling = this.$el.next(".umb-grid")
            .find(".grid-section > div:first-child .column > div > *:first-child").first();
        var siblingBg = sibling.css("background-color");
        if (siblingBg === "rgba(0, 0, 0, 0)" || siblingBg === "transparent" || siblingBg === "#fff") {
            this.$el.css({
                "margin-bottom": KeepTheRhythm_1.KeepTheRhythmComponent.baseline * 2,
                "padding-bottom": KeepTheRhythm_1.KeepTheRhythmComponent.baseline * 2
            });
        }
    };
    return HeroBannerHomeComponent;
}(app_1.Component));
exports.HeroBannerHomeComponent = HeroBannerHomeComponent;
var heroBannerHomeComponent = new HeroBannerHomeComponent();
